export enum CareerProfileEditorUrlParams {
  returnUrl = 'returnUrl',
  section = 'section',
}
